import styled from "styled-components";
import media from "constants/media";

import Description from "components/shared/hero/description/Description";

export const Text = styled(Description)`
    margin-bottom: 35px;

    ${media.mdUp`
        margin-bottom: 100px;
    `}
`;

export const Stats = styled.ul`
    width: 100%;
    max-width: 580px;
    margin: 0 auto;

    list-style: none;

    ${media.mdUp`
        display: flex;
        flex-wrap: wrap;
    `}
`;

export const Stat = styled.li`
    margin-bottom: 35px;

    text-align: center;

    ${media.mdUp`
        width: 50%;
        margin-bottom: 18px;
    `}
`;

export const Number = styled.span`
    display: block;
    margin-bottom: 5px;

    font-size: 35px;
    line-height: 40px;

    ${media.mdUp`
        margin-bottom: 8px;

        font-size: 60px;
        line-height: 74px;
    `}
`;

export const Label = styled.span`
    display: block;

    font-size: 14px;
    line-height: 20px;

    ${media.mdUp`
        font-size: 15px;
        line-height: 25px;
    `}
`;

export const Background = styled.div`
    position: absolute;
    top: 0;
    left: 50%;

    width: 174px;
    height: 1976px;
    margin: 20px 0 0 30px;

    background: url("/images/about-letters-mobile.svg") no-repeat top center;

    ${media.mdUp`
        top: -170px;

        width: 1500px;
        height: 2052px;
        margin: 300px 0 0 30px;

        transform: translateX(-50%);
        background: url("/images/about-letters-desktop.svg") no-repeat top center;
        
    `}
`;
